import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { DashboardEntity } from './dashboard.entity';

@Index('idx_active', ['isActive'], {})
@Index('idx_dashboard', ['fkDashboardId'], {})
@Index('idx_filter_key', ['filterKey'], {})
@Index('idx_global', ['isGlobal'], {})
@Entity('dashboard_filter')
export class DashboardFilterEntity extends BaseEntity {
	@Column('int', { name: '_fk__dashboard__id', unsigned: true })
	public fkDashboardId!: number;

	@Column('varchar', { name: 'filterKey', length: 100 })
	public filterKey!: string;

	@Column('varchar', { name: 'filterType', length: 50 })
	public filterType!: string;

	@Column('json', { name: 'filterValue', nullable: true })
	public filterValue!: object | null;

	@Column('tinyint', {
		name: 'isActive',
		nullable: true,
		width: 1,
		default: () => "'1'",
	})
	public isActive!: boolean | null;

	@Column('tinyint', {
		name: 'isGlobal',
		nullable: true,
		width: 1,
		default: () => "'0'",
	})
	public isGlobal!: boolean | null;

	@Column('int', {
		name: 'sortOrder',
		nullable: true,
		unsigned: true,
		default: () => "'0'",
	})
	public sortOrder!: number | null;

	@ManyToOne(() => DashboardEntity, (dashboard) => dashboard.dashboardFilters, {
		onDelete: 'CASCADE',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk__dashboard__id', referencedColumnName: 'id' }])
	public fkDashboard!: DashboardEntity;
}
